import axiosIns from '@/api/axios';
import axiosInsAcademy from '@/api/axios-ugems-academy.js';

export default {
  // Get all training with pagination
  getTrainings(params = {}) {
    const queryParams = new URLSearchParams();
    queryParams.append('training_scope', 'BIB-Partner');
    
    if (params.page) queryParams.append('page', params.page);
    if (params.limit) queryParams.append('limit', params.limit);
    if (params.search) queryParams.append('search', params.search);
    
    return axiosIns.get(`/training?${queryParams.toString()}`);
  },

  // Get positions
  getPositions() {
    return axiosInsAcademy.get('/position-levels');
  },

  // Get training mapping mitra by position level to check selected trainings
  getTrainingMitra(positionLevelId) {
    return axiosInsAcademy.get('/contractor-training-mappings', {
      params: { positionLevelId }
    });
  },

  // Save contractor training mappings
  saveContractorTrainingMapping(data) {
    return axiosInsAcademy.put('/contractor-training-mappings', data);
  },

  // Bulk upload contractor training mappings
  uploadBulkMapping(formData) {
    return axiosInsAcademy.post('/contractor-training-mappings/bulk-create', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  },

  downloadTemplate() {
    return axiosInsAcademy.get('/contractor-training-mappings/bulk-download-template', {
      responseType: 'blob'
    });
  }
};
